<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>

    <!-- 科室导航 -->
    <div class="container-width x-medical mb50">
      <div class="title">盛京名医</div>
      <section class="department-navigation">
        <div class="container-width">
          <ul class="ulPartList">
            <li class="li" v-for="(item, index) in list" :key="index">
              <a @click="showDialog(item)" class="wh_dot"> {{ item.name }}</a>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
      </section>
    </div>
    <FUNCTION></FUNCTION>
    <el-dialog :visible.sync="dialogVisible" width="81%">
      <div class="d-body">
        <div class="d-title">{{ dialogContent.name }}</div>
        <div class="d-content">
          <section v-for="(item, index) in dialogContent.children" :key="index">
            <div class="d-department">
              <span @click="gomingyi(item)">[{{ item.name }}]</span>
              <a class="more" @click="gomingyi(item)" title="点击查看相关医生"
                >相关医生>></a
              >
            </div>
            <p class="d5" v-if="item.children.length">相关病房:</p>
            <ul>
              <li v-for="(m, n) in item.children" :key="n">
                <a title="点击查看相关医生" @click="gomingyi(m)">
                  {{ m.name }}</a
                >
              </li>
            </ul>
          </section>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import service from "../../service/ylts";
import BANNER from "../../components/banner/ylts";
export default {
  name: "MINGYI",
  props: {},
  data() {
    return {
      navigationData: [
      {
          name: "科室介绍",
          path: "/ylts/home",
          width: "31%",
        },
        {
          name: "盛京名医",
          path: "/ylts/mingyi",
          width: "31%",
        },
        {
          name: "国家临床重点专科",
          path: "/ylts/zhuanke",
          width: "38%",
        },
        {
          name: "特色医疗中心",
          path: "/ylts/tese",
        },
        {
          name: "护理专业发展",
          path: "/ylts/huli",
        },
      ],
      currentPath: "/ylts/mingyi",
      list: [],
      dialogVisible: false,
      dialogContent: [],
    };
  },
  components: { BANNER },
  methods: {
    gomingyi(e) {
      let articleId = e.id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/article/${articleId}`,
      });
      window.open(href, "_self");
    },
    showDialog(e) {
      this.dialogContent = e;
      this.dialogVisible = !this.dialogVisible;
    },
    removeHTMLTag(str) {
      str = str ? str.replace(/<\/?.+?\/?>/g, "") : "";
      return str;
    },
  },
  mounted() {
    service.getKsTree("", (res) => {
      if (res.children.length) {
        res.children.map((item) => {
          if (item.children.length) {
            item.children.map((m) => {
              m.description = this.removeHTMLTag(m.description) || "";
            });
          }
        });
        this.list = res.children || [];
      }
    });
  },
};
</script>

<style scoped lang="scss">
.title {
  margin-top: 50px;
  font-size: 1.4rem;
  font-weight: bold;
  text-align: center;
}
.d-body {
  width: 100%;
  height: 60vh;
  overflow-y: scroll;
  .d-title {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #333;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .d-content {
    .d-department {
      color: #00479d;
      font-size: 1.4rem;
      cursor: pointer;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
      background: #e5f5ff;
      padding: 5px 20px 5px 20px;
      box-sizing: border-box;
      a {
        color: #666;
        font-size: 0.85rem;
      }
    }
    .d-description {
      color: #333;
      font-size: 1rem;
      line-height: 30px;
      margin-top: 5px;
      padding-left: 20px;
    }
    .d5 {
      color: #00479d;
      padding-left: 20px;
      margin-top: 20px;
    }
    ul {
      display: -webkit-flex;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      padding-left: 20px;
      li {
        width: 25%;
        margin-top: 5px;
        position: relative;
        padding-left: 20px;
        box-sizing: border-box;
        a {
          color: #333;
          font-size: 1rem;
          cursor: pointer;
        }
      }
      li:before {
        content: "";
        position: absolute;
        width: 6px;
        height: 6px;
        background: #00479d;
        border-radius: 50%;
        left: 5px;
        top: 8px;
      }
    }
  }
}
@media only screen and (max-width: 728px) {
  .title {
    margin-top: 20px;
    font-size: 1.4rem;
  }
  .d-body {
    width: 100%;
    height: 60vh;
    overflow-y: scroll;
    .d-title {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      color: #333;
      font-size: 1.6rem;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .d-content {
      .d-department {
        font-size: 0.9rem;
        padding: 5px;
        box-sizing: border-box;
        a {
          color: #666;
          font-size: 0.85rem;
        }
      }
      .d-description {
        color: #333;
        font-size: 0.8rem;
        line-height: 24px;
        margin-top: 5px;
        padding-left: 20px;
      }
      .d5 {
        color: #00479d;
        padding-left: 20px;
        margin-top: 10px;
        font-size: 1rem;
      }
      ul {
        padding-left: 10px;
        li {
          width: 100%;
          margin-top: 5px;
          padding-left: 10px;
          box-sizing: border-box;
          a {
            color: #333;
            font-size: 0.8rem;
            cursor: pointer;
          }
        }
        li:before {
          content: "";
          position: absolute;
          width: 6px;
          height: 6px;
          background: #00479d;
          border-radius: 50%;
          left: 0px;
          top: 10px;
        }
      }
    }
  }
  .x-title {
    margin-top: 15px;
  }
}
</style>
